import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { FLIP, PREVENT_OVERFLOW, ARROW } from '@cian/popper-fork';
import { clsx } from 'clsx';
import { Popper } from '../../../internal/components/Popper';
import { CloseButton } from '../../../internal/components/CloseButton';
import { Outside } from '../../../services';
import { getStyles } from './styles';

/**
 * Компонент для создания кастомных тултипов
 *
 * @export
 * @param {ICustomTooltipProps} props
 * @returns
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function CustomTooltip(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'white' : _ref$theme,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'S' : _ref$size,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? 450 : _ref$maxWidth,
    _ref$portal = _ref.portal,
    portal = _ref$portal === void 0 ? true : _ref$portal,
    portalElement = _ref.portalElement,
    _ref$flip = _ref.flip,
    flip = _ref$flip === void 0 ? true : _ref$flip,
    _ref$preventOverflow = _ref.preventOverflow,
    preventOverflow = _ref$preventOverflow === void 0 ? true : _ref$preventOverflow,
    content = _ref.content,
    header = _ref.header,
    anchorRef = _ref.anchorRef,
    open = _ref.open,
    arrow = _ref.arrow,
    closeButton = _ref.closeButton,
    outside = _ref.outside,
    minHeight = _ref.minHeight,
    withoutPadding = _ref.withoutPadding,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave;
  var styles = getStyles(theme, size);
  var modifiers = React.useMemo(function () {
    return [flip && FLIP, preventOverflow && PREVENT_OVERFLOW, arrow && _objectSpread(_objectSpread({}, ARROW), {}, {
      options: {
        padding: 12
      }
    })].filter(Boolean);
  }, [flip, preventOverflow, arrow]);
  var tooltip = /*#__PURE__*/_jsxs("div", {
    className: clsx(styles['tooltip'], arrow && styles['arrow_tooltip'], closeButton && styles['close_tooltip'], withoutPadding && styles['without_padding']),
    style: {
      minHeight: minHeight,
      maxWidth: maxWidth
    },
    children: [closeButton && /*#__PURE__*/_jsx(CloseButton, {
      onClick: onClose,
      className: clsx(styles['close']),
      size: 12,
      theme: getCloseTheme(theme)
    }), arrow && /*#__PURE__*/_jsx("div", {
      "data-popper-arrow": true,
      className: styles['arrow']
    }), header && /*#__PURE__*/_jsx("div", {
      className: clsx(styles['header']),
      children: header
    }), content]
  });
  return /*#__PURE__*/_jsxs(Popper, {
    open: open,
    anchorRef: anchorRef,
    placement: placement,
    portal: portal,
    portalElement: portalElement,
    modifiers: modifiers,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    children: [outside && /*#__PURE__*/_jsx(Outside, {
      onOutside: onClose,
      active: true,
      insideRefs: [anchorRef],
      children: tooltip
    }), !outside && tooltip]
  });
}
function getCloseTheme(tooltipTheme) {
  switch (tooltipTheme) {
    case 'black':
      return 'gray';
    case 'gray':
      return 'light';
    case 'blue':
      return 'light';
    case 'white':
      return 'dark';
  }
}